import DialogContent from '@mui/material/DialogContent';

type DialogContentProps = React.ComponentProps<typeof DialogContent>;

const MUIDialogContent = (props: DialogContentProps) => {
  return (
    <DialogContent data-testid="mui-dialog-content" tabIndex={0} {...props} />
  );
};

export default MUIDialogContent;
